import { Component, HostBinding, Input } from '@angular/core';

@Component({
	selector: 'cm-progress-indicator',
	templateUrl: './cm-progress-indicator.component.html',
	styleUrls: ['./cm-progress-indicator.component.scss'],
	standalone: false,
})
export class CmProgressIndicatorComponent {
	@Input() display: 'circle' | 'bar' = 'bar';
	@Input() currentValue: number;
	@Input() maximumValue: number;
	@Input() size: number = 64;
	@Input() hideText: boolean = false;

	ngOnInit(): void {
		// this is the adjustment for styling progress bar for when the maximum value is 0
		if (this.maximumValue === 0) {
			this.maximumValue = 1;
		}
	}

	@HostBinding('style.width')
	get width() {
		return this.display === 'circle' ? `${this.sizeInREM}rem` : '100%';
	}

	@HostBinding('style.height')
	get height() {
		return this.display === 'circle' ? `${this.sizeInREM}rem` : '100%';
	}

	@HostBinding('style.--p')
	get percentageInt(): string {
		return Math.round(this.percentage * 100).toString() + '%';
	}

	get sizeInREM(): number {
		return this.size / 16;
	}

	get percentage(): number {
		return this.currentValue / this.maximumValue;
	}

	constructor() {}
}
